/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SurveyEngine_Models_ApiCommandErrorResult } from '../models/SurveyEngine_Models_ApiCommandErrorResult';
import type { SurveyEngine_Models_ApiCommandResult } from '../models/SurveyEngine_Models_ApiCommandResult';
import type { SurveyEngine_Models_ApiPanelistScheduleResult } from '../models/SurveyEngine_Models_ApiPanelistScheduleResult';
import type { SurveyEngine_Models_ApiPanelistStudiesResult } from '../models/SurveyEngine_Models_ApiPanelistStudiesResult';
import type { SurveyEngine_Models_ApiRefreshTokenResult } from '../models/SurveyEngine_Models_ApiRefreshTokenResult';
import type { SurveyEngine_Models_ApiResult } from '../models/SurveyEngine_Models_ApiResult';
import type { SurveyEngine_Models_ApiScheduleResult } from '../models/SurveyEngine_Models_ApiScheduleResult';
import type { SurveyEngine_Models_ApiSessionResult } from '../models/SurveyEngine_Models_ApiSessionResult';
import type { SurveyEngine_Models_ApiSurveyResult } from '../models/SurveyEngine_Models_ApiSurveyResult';
import type { SurveyEngine_Models_ApiThemesResult } from '../models/SurveyEngine_Models_ApiThemesResult';
import type { SurveyEngine_Models_AuthenticateUserResponse } from '../models/SurveyEngine_Models_AuthenticateUserResponse';
import type { SurveyEngine_Models_BaseResponse } from '../models/SurveyEngine_Models_BaseResponse';
import type { SurveyEngine_Models_CompletedResponse } from '../models/SurveyEngine_Models_CompletedResponse';
import type { SurveyEngine_Models_DispoSelectResponse } from '../models/SurveyEngine_Models_DispoSelectResponse';
import type { SurveyEngine_Models_DisqualifyResponse } from '../models/SurveyEngine_Models_DisqualifyResponse';
import type { SurveyEngine_Models_DynamicResponseResponse } from '../models/SurveyEngine_Models_DynamicResponseResponse';
import type { SurveyEngine_Models_FileUploadResponse } from '../models/SurveyEngine_Models_FileUploadResponse';
import type { SurveyEngine_Models_FileUploadResult } from '../models/SurveyEngine_Models_FileUploadResult';
import type { SurveyEngine_Models_GetResponseResponse } from '../models/SurveyEngine_Models_GetResponseResponse';
import type { SurveyEngine_Models_GetValueResponse } from '../models/SurveyEngine_Models_GetValueResponse';
import type { SurveyEngine_Models_MultiResponseResponse } from '../models/SurveyEngine_Models_MultiResponseResponse';
import type { SurveyEngine_Models_Platform } from '../models/SurveyEngine_Models_Platform';
import type { SurveyEngine_Models_PlayValueResponse } from '../models/SurveyEngine_Models_PlayValueResponse';
import type { SurveyEngine_Models_QualifyResponse } from '../models/SurveyEngine_Models_QualifyResponse';
import type { SurveyEngine_Models_RankingResponse } from '../models/SurveyEngine_Models_RankingResponse';
import type { SurveyEngine_Models_RecordMessageResponse } from '../models/SurveyEngine_Models_RecordMessageResponse';
import type { SurveyEngine_Models_RecruitResponse } from '../models/SurveyEngine_Models_RecruitResponse';
import type { SurveyEngine_Models_ScaleMatrixResponse } from '../models/SurveyEngine_Models_ScaleMatrixResponse';
import type { SurveyEngine_Models_ScaleResponse } from '../models/SurveyEngine_Models_ScaleResponse';
import type { SurveyEngine_Models_SEPostSurveyScheduleOperation } from '../models/SurveyEngine_Models_SEPostSurveyScheduleOperation';
import type { SurveyEngine_Models_SESurveyConfirmOperation } from '../models/SurveyEngine_Models_SESurveyConfirmOperation';
import type { SurveyEngine_Models_SetLanguageResponse } from '../models/SurveyEngine_Models_SetLanguageResponse';
import type { SurveyEngine_Models_SliderResponse } from '../models/SurveyEngine_Models_SliderResponse';
import type { SurveyEngine_Models_StartGridResponse } from '../models/SurveyEngine_Models_StartGridResponse';
import type { SurveyEngine_Models_StartSurveyRequestBody } from '../models/SurveyEngine_Models_StartSurveyRequestBody';
import type { SurveyEngine_Models_SurveyCompleteResponse } from '../models/SurveyEngine_Models_SurveyCompleteResponse';
import type { SurveyEngine_Models_SurveyInstance } from '../models/SurveyEngine_Models_SurveyInstance';
import type { SurveyEngine_Models_TerminateResponse } from '../models/SurveyEngine_Models_TerminateResponse';
import type { SurveyEngine_Models_VideoResponse } from '../models/SurveyEngine_Models_VideoResponse';
import type { SurveyEngine_Models_WebCaptureResponse } from '../models/SurveyEngine_Models_WebCaptureResponse';
import type { SurveyEngine_Models_WebTransferResponse } from '../models/SurveyEngine_Models_WebTransferResponse';
import type { SurveyService_Application_Commands_SubmitCalendarSchedule_CalendarURLs } from '../models/SurveyService_Application_Commands_SubmitCalendarSchedule_CalendarURLs';
import type { SurveyService_Models_AnnounceResponse } from '../models/SurveyService_Models_AnnounceResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SurveyApiService {

    /**
     * Get Clinet IpAddress.
     * Returns Clinet Ip Address.
     * @returns SurveyEngine_Models_ApiCommandResult OK
     * @throws ApiError
     */
    public static getV1ClientIp(): CancelablePromise<SurveyEngine_Models_ApiCommandResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/ClientIP',
            errors: {
                400: `Error`,
            },
        });
    }

    /**
     * Get next survey UI question, if not in the start of the survey, body must contain the answer to previous question.
     * Returns the next question(s) the user is required to respond to.  Calling this repeatedly will return the same set of questions until valid answers are supplied.
     * @param surveyInstanceId Survey Instance ID
     * @param platform The platform of the consumer requesting the next question.
     * @param requestBody Answers from the previous questions returned, or null for the first request
     * @returns SurveyEngine_Models_ApiCommandResult OK
     * @throws ApiError
     */
    public static postV1SurveyNextQuestion(
surveyInstanceId: string,
platform: SurveyEngine_Models_Platform,
requestBody?: Array<(SurveyEngine_Models_BaseResponse | SurveyService_Models_AnnounceResponse | SurveyEngine_Models_AuthenticateUserResponse | SurveyEngine_Models_CompletedResponse | SurveyEngine_Models_DispoSelectResponse | SurveyEngine_Models_DisqualifyResponse | SurveyEngine_Models_DynamicResponseResponse | SurveyEngine_Models_FileUploadResponse | SurveyEngine_Models_GetResponseResponse | SurveyEngine_Models_GetValueResponse | SurveyEngine_Models_MultiResponseResponse | SurveyEngine_Models_PlayValueResponse | SurveyEngine_Models_QualifyResponse | SurveyEngine_Models_RankingResponse | SurveyEngine_Models_RecordMessageResponse | SurveyEngine_Models_RecruitResponse | SurveyEngine_Models_ScaleMatrixResponse | SurveyEngine_Models_ScaleResponse | SurveyEngine_Models_SetLanguageResponse | SurveyEngine_Models_SliderResponse | SurveyEngine_Models_StartGridResponse | SurveyEngine_Models_SurveyCompleteResponse | SurveyEngine_Models_TerminateResponse | SurveyEngine_Models_VideoResponse | SurveyEngine_Models_WebCaptureResponse | SurveyEngine_Models_WebTransferResponse)>,
): CancelablePromise<SurveyEngine_Models_ApiCommandResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/survey/{surveyInstanceId}/{platform}/nextQuestion',
            path: {
                'surveyInstanceId': surveyInstanceId,
                'platform': platform,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error`,
                404: `Invalid Survey Instance ID`,
            },
        });
    }

    /**
     * Get previous survey UI question.
     * StudyId Engine will remain on the current question if it is not allowed to go back or if it is already at the beginning
     * @param surveyInstanceId Survey Instance ID
     * @param platform Platform
     * @param showPreviousResponse Show Previous Response
     * @returns SurveyEngine_Models_ApiCommandResult OK
     * @throws ApiError
     */
    public static postV1SurveyPreviousQuestion(
surveyInstanceId: string,
platform: SurveyEngine_Models_Platform,
showPreviousResponse: boolean,
): CancelablePromise<SurveyEngine_Models_ApiCommandResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/survey/{surveyInstanceId}/{platform}/previousQuestion',
            path: {
                'surveyInstanceId': surveyInstanceId,
                'platform': platform,
            },
            query: {
                'showPreviousResponse': showPreviousResponse,
            },
            errors: {
                400: `Error`,
                404: `Invalid Survey Instance ID`,
            },
        });
    }

    /**
     * Submit Schedule Pending Confirmation.
     * Adds the panelist to the Sessions pending confirmation, to hold the seat until confirmation.If the Panelist fails to confirm he will be removed from the session.
     * @param surveyInstanceId Survey Instance ID
     * @param platform The platform of the consumer requesting.
     * @param operation Operation to add panelist pending confirmation or remove from all sessions
     * @param requestBody Session id list
     * @returns SurveyEngine_Models_ApiCommandResult OK
     * @throws ApiError
     */
    public static postV1SurveySubmitPendingConfirmation(
surveyInstanceId: string,
platform: SurveyEngine_Models_Platform,
operation?: SurveyEngine_Models_SESurveyConfirmOperation,
requestBody?: Array<number>,
): CancelablePromise<SurveyEngine_Models_ApiCommandResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/survey/{surveyInstanceId}/{platform}/SubmitPendingConfirmation',
            path: {
                'surveyInstanceId': surveyInstanceId,
                'platform': platform,
            },
            query: {
                'operation': operation,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error`,
                404: `Invalid Survey Instance ID`,
            },
        });
    }

    /**
     * Refresh Survey Token.
     * Will return a new single survey token with the token validity extended to the same duration as the current token.
     * @param studyId Study ID
     * @param panelistId Panelist Id
     * @param postSurvey True for Post survey , False for Survey
     * @returns SurveyEngine_Models_ApiRefreshTokenResult OK
     * @throws ApiError
     */
    public static postV1SurveyRefreshToken(
studyId: number,
panelistId: number,
postSurvey?: boolean,
): CancelablePromise<SurveyEngine_Models_ApiRefreshTokenResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/survey/refreshToken',
            query: {
                'StudyID': studyId,
                'PanelistID': panelistId,
                'PostSurvey': postSurvey,
            },
            errors: {
                400: `Error`,
                404: `Error`,
            },
        });
    }

    /**
     * Start survey
     * Initiate a survey and return a unique instance Id to keep track of this survey being conducted.
     * @param platform 
     * @param studyId Id of the study.  The latest compiled questionnaire for this study will be used.
     * @param forceRestart Forces the survey to restart from the beginning
     * @param psguid If present, the guid from the link authorizing the panelist to take this particular survey
     * @param requestBody body object of the request
     * @returns SurveyEngine_Models_SurveyInstance Success
     * @throws ApiError
     */
    public static postV1SurveyStart(
platform: SurveyEngine_Models_Platform,
studyId?: number,
forceRestart?: boolean,
psguid?: string,
requestBody?: SurveyEngine_Models_StartSurveyRequestBody,
): CancelablePromise<SurveyEngine_Models_SurveyInstance> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/survey/{platform}/start',
            path: {
                'platform': platform,
            },
            query: {
                'studyId': studyId,
                'forceRestart': forceRestart,
                'psguid': psguid,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Invalid options supplied`,
                404: `Survey not found`,
            },
        });
    }

    /**
     * Start survey
     * Initiate a survey and return a unique instance Id to keep track of this survey being conducted.
     * @param platform 
     * @param uid Uid for survey
     * @param forceRestart Forces the survey to restart from the beginning
     * @param psguid Optional PSGUID from the link authorizing the panelist to take this particular survey
     * @param requestBody body object of the request
     * @returns SurveyEngine_Models_SurveyInstance Success
     * @throws ApiError
     */
    public static postV1SurveyStart1(
platform: SurveyEngine_Models_Platform,
uid: string,
forceRestart?: boolean,
psguid?: string,
requestBody?: SurveyEngine_Models_StartSurveyRequestBody,
): CancelablePromise<SurveyEngine_Models_SurveyInstance> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/survey/{platform}/start/{uid}',
            path: {
                'platform': platform,
                'uid': uid,
            },
            query: {
                'forceRestart': forceRestart,
                'psguid': psguid,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Invalid options supplied`,
                404: `Survey not found`,
            },
        });
    }

    /**
     * Start Participant survey
     * Initiate a survey and return a unique instance Id to keep track of this survey being conducted.
     * @param platform 
     * @param studyId Id of the study.  The latest compiled questionnaire for this study will be used.
     * @param panelistId Id of the panelist.
     * @param forceRestart Forces the survey to restart from the beginning
     * @param requestBody body object of the request
     * @returns SurveyEngine_Models_SurveyInstance Success
     * @throws ApiError
     */
    public static postV1SurveyStartparticipant(
platform: SurveyEngine_Models_Platform,
studyId?: number,
panelistId?: number,
forceRestart?: boolean,
requestBody?: SurveyEngine_Models_StartSurveyRequestBody,
): CancelablePromise<SurveyEngine_Models_SurveyInstance> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/survey/{platform}/startparticipant',
            path: {
                'platform': platform,
            },
            query: {
                'studyId': studyId,
                'panelistId': panelistId,
                'forceRestart': forceRestart,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Invalid options supplied`,
                404: `SurveyID or PanelistID not found`,
            },
        });
    }

    /**
     * Uploads a file
     * @param surveyInstanceId Survey Instance ID
     * @param formData 
     * @returns SurveyEngine_Models_FileUploadResult Success
     * @throws ApiError
     */
    public static postV1SurveyUploadFile(
surveyInstanceId: string,
formData?: {
file?: Blob;
},
): CancelablePromise<SurveyEngine_Models_FileUploadResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/survey/uploadFile/{surveyInstanceId}',
            path: {
                'surveyInstanceId': surveyInstanceId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Invalid options supplied`,
                404: `Survey Instance ID not found`,
            },
        });
    }

    /**
     * Deletes a file
     * @param surveyInstanceId Survey Instance ID
     * @returns SurveyEngine_Models_FileUploadResult Success
     * @throws ApiError
     */
    public static postV1SurveyDeleteFile(
surveyInstanceId: string,
): CancelablePromise<SurveyEngine_Models_FileUploadResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/survey/deleteFile/{surveyInstanceId}',
            path: {
                'surveyInstanceId': surveyInstanceId,
            },
            errors: {
                400: `Invalid options supplied`,
                404: `Survey Instance ID not found`,
            },
        });
    }

    /**
     * Abandons a survey and removes all cached data from questionnaire service
     * @param surveyInstanceId Survey Instance ID
     * @returns any Success
     * @throws ApiError
     */
    public static postV1SurveyAbandon(
surveyInstanceId: string,
): CancelablePromise<(SurveyEngine_Models_ApiResult | SurveyEngine_Models_ApiCommandResult | SurveyEngine_Models_ApiPanelistStudiesResult | SurveyEngine_Models_ApiRefreshTokenResult | SurveyEngine_Models_ApiCommandErrorResult | SurveyEngine_Models_ApiScheduleResult | SurveyEngine_Models_ApiSessionResult | SurveyEngine_Models_ApiPanelistScheduleResult | SurveyEngine_Models_ApiSurveyResult | SurveyEngine_Models_ApiThemesResult)> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/survey/{surveyInstanceId}/abandon',
            path: {
                'surveyInstanceId': surveyInstanceId,
            },
            errors: {
                400: `Invalid options supplied`,
                404: `Survey Instance ID not found`,
            },
        });
    }

    /**
     * Returns studies the panelist is in and their status
     * @param panelistId PanelistID
     * @returns SurveyEngine_Models_ApiPanelistStudiesResult Success
     * @throws ApiError
     */
    public static getV1SurveyGetPanelistStudies(
panelistId: number,
): CancelablePromise<SurveyEngine_Models_ApiPanelistStudiesResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/survey/getPanelistStudies',
            query: {
                'panelistId': panelistId,
            },
            errors: {
                400: `Invalid options supplied`,
                404: `PanelistID not found`,
            },
        });
    }

    /**
     * Get available sessions for panelists
     * @param panelistId PanelistId
     * @param studyId StudyId
     * @param orfIndex Open Recruitment Index, ignored for studies that are not Open Recruitment
     * @returns SurveyEngine_Models_ApiSessionResult Success
     * @throws ApiError
     */
    public static getV1SurveyPanelistAvailableSessions(
panelistId: number,
studyId: number,
orfIndex: number,
): CancelablePromise<SurveyEngine_Models_ApiSessionResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/survey/panelistAvailableSessions',
            query: {
                'panelistId': panelistId,
                'studyId': studyId,
                'orfIndex': orfIndex,
            },
            errors: {
                400: `Invalid options supplied`,
                404: `Panelist ID or Study ID is not found`,
            },
        });
    }

    /**
     * Get current scheduled sessions of a panelist in the study
     * @param panelistId PanelistId
     * @param studyId StudyId
     * @returns SurveyEngine_Models_ApiPanelistScheduleResult Success
     * @throws ApiError
     */
    public static getV1SurveyPanelistScheduledSessions(
panelistId: number,
studyId: number,
): CancelablePromise<SurveyEngine_Models_ApiPanelistScheduleResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/survey/panelistScheduledSessions',
            query: {
                'panelistId': panelistId,
                'studyId': studyId,
            },
            errors: {
                400: `Invalid options supplied`,
                404: `PanelistID or StudyID is not found`,
            },
        });
    }

    /**
     * Submit schedule for a panelist, Post Survey.
     * @param panelistId PanelistId
     * @param studyId StudyID
     * @param operationType Operation Type, one of Confirm/Cancel/Reschedule
     * @param requestBody The Session Ids they selected.Mandatory for reschedule, ignored for Confirm and Cancel
     * @returns any Success
     * @throws ApiError
     */
    public static postV1SurveySubmitSchedule(
panelistId: number,
studyId: number,
operationType?: SurveyEngine_Models_SEPostSurveyScheduleOperation,
requestBody?: Array<number>,
): CancelablePromise<(SurveyEngine_Models_ApiResult | SurveyEngine_Models_ApiCommandResult | SurveyEngine_Models_ApiPanelistStudiesResult | SurveyEngine_Models_ApiRefreshTokenResult | SurveyEngine_Models_ApiCommandErrorResult | SurveyEngine_Models_ApiScheduleResult | SurveyEngine_Models_ApiSessionResult | SurveyEngine_Models_ApiPanelistScheduleResult | SurveyEngine_Models_ApiSurveyResult | SurveyEngine_Models_ApiThemesResult)> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/survey/submitSchedule',
            query: {
                'panelistId': panelistId,
                'studyId': studyId,
                'operationType': operationType,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Invalid options supplied`,
                404: `PanelistID or StudyID is not found`,
            },
        });
    }

    /**
     * Submit Calendar study Schedule for a panelist, Post Survey.
     * @param panelistId PanelistId
     * @param studyId StudyID
     * @param requestBody Calendar Event URL details
     * @returns any Success
     * @throws ApiError
     */
    public static postV1SurveySubmitCalendarSchedule(
panelistId: number,
studyId: number,
requestBody?: SurveyService_Application_Commands_SubmitCalendarSchedule_CalendarURLs,
): CancelablePromise<(SurveyEngine_Models_ApiResult | SurveyEngine_Models_ApiCommandResult | SurveyEngine_Models_ApiPanelistStudiesResult | SurveyEngine_Models_ApiRefreshTokenResult | SurveyEngine_Models_ApiCommandErrorResult | SurveyEngine_Models_ApiScheduleResult | SurveyEngine_Models_ApiSessionResult | SurveyEngine_Models_ApiPanelistScheduleResult | SurveyEngine_Models_ApiSurveyResult | SurveyEngine_Models_ApiThemesResult)> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/survey/SubmitCalendarSchedule',
            query: {
                'panelistId': panelistId,
                'studyId': studyId,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Invalid options supplied`,
                404: `PanelistID or StudyID is not found`,
            },
        });
    }

    /**
     * Update the panelist status in external study
     * @param refId psguid
     * @param id Study Id
     * @param xStatus Status
     * @returns SurveyEngine_Models_SurveyInstance Success
     * @throws ApiError
     */
    public static postExternalStudy(
refId: string,
id: number,
xStatus: number,
): CancelablePromise<SurveyEngine_Models_SurveyInstance> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ExternalStudy',
            query: {
                'refID': refId,
                'ID': id,
                'XStatus': xStatus,
            },
            errors: {
                400: `Invalid options supplied`,
                404: `Survey not found`,
            },
        });
    }

    /**
     * Update the panelist status in external study
     * @param refId psguid
     * @param id Study Id
     * @param xStatus Status
     * @returns SurveyEngine_Models_SurveyInstance Success
     * @throws ApiError
     */
    public static postV1ExternalStudy(
refId: string,
id: number,
xStatus: number,
): CancelablePromise<SurveyEngine_Models_SurveyInstance> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/ExternalStudy',
            query: {
                'refID': refId,
                'ID': id,
                'XStatus': xStatus,
            },
            errors: {
                400: `Invalid options supplied`,
                404: `Survey not found`,
            },
        });
    }

}
